import { claimMysteryBox } from "@/api/activity"
import { formatCurrency } from "@/utils/commonFunction"

export interface MisteryBoxConfigData {
    show: boolean
    depositButtonConfig: any
    mysteryRewardButtonConfig: any
    nonDepositButtonConfig: any
    todayDepositButtonConfig: any
    totalClaimedAmount: number
    totalPrizeAmount: number | string
    isEmptyList: boolean
}

export interface ClaimRewardParams {
  rewardType?: number;
  exchangeType?: number;
}

export interface ClaimRewardResult {
  reward: any;
}

export interface ServiceCallbacks {
  onStart?: () => void;
  onSuccess?: (result: ClaimRewardResult) => void;
  onError?: (errorMessage: string) => void;
  onFinally?: () => void;
}

export function getFirstAndLastAmount(dataList: any[]) {
    if (!Array.isArray(dataList) || dataList.length === 0) {
        return null;
    }

    const firstAmount = dataList[0].amount;
    const lastAmount = dataList[dataList.length - 1].amount;

    return ' R$ ' + formatCurrency(firstAmount) + ' - ' + formatCurrency(lastAmount);
}

export function getPeoplePerDay(data: any) {

    if (data?.isLoop == 2) {
        const numOfSlots = data.todayDepositButton.rewardsDrawTime.split('/').length
        const numberOfRewards = Number(data.todayDepositButton.totalNumOfRewards)
        const rewardsPerSlot = Math.floor(numberOfRewards / (numOfSlots - 1))

        return rewardsPerSlot

    } else {

        return data?.totalNumOfRewards

    }
}

export async function processClaimReward(
  params: ClaimRewardParams,
  callbacks: ServiceCallbacks = {}
): Promise<ClaimRewardResult | null> {
  const { onStart, onSuccess, onError, onFinally } = callbacks;

  onStart?.();

  try {
    const response = await claimMysteryBox({ rewardType: params.rewardType });
    const rewardData = response.data;
    
    const result: ClaimRewardResult = {
      reward: rewardData.reward,
    };

    onSuccess?.(result);
    return result;
  } catch (err: any) {
    if (err?.code !== 401) {
      const errorMessage = typeof err === 'string' ? err : err?.message || 'An error occurred';
      onError?.(errorMessage);
    }
    return null;
  } finally {
    onFinally?.();
  }
}